import { combineReducers } from 'redux';
import orderAppState from './order';
import errorsState from './errors';
import rentalAppState from './rental';
import appearanceAppState from './appearance';

const rootReducer = combineReducers({
  appearanceAppState,
  orderAppState,
  rentalAppState,
  errorsState,
});

export default rootReducer;
